import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Right from '../../right/Right';
import './MealPlanner.css';
import { fetchInitialData } from "../../fetchData";
import Service from '../../service/Service';
import * as actions from './actions';
import withContext from "../../../withContext";

const service = new Service();

class MealPlannerDisclaimer extends Component {
    constructor(props) {
        super(props);
        let isApp='';
        if (this.props.location.search.includes('from=app')) {
            isApp=true;
        }
        this.state = {
            metaTitle: "Disclaimer: Baby & Toddlers Meal Plans - FirstCry Parenting",
            metaDescription: [],
            isApp: isApp
        };
    }
    
    componentDidMount() {
        this.setState({ windowWidth: window.outerWidth});
        // console.log("windowWidth--", window.outerWidth);
        if (this.state.isApp) {
            document.querySelector('.main-container').style.background="#eee";
            actions.loadCallbackFile();
        }
    }

    domClick(event) {
        console.log("event Dom========>",event.target)
        if (event.target.classList.contains('share-overlay')) {
            let ary = document.getElementsByClassName('sharing-options');
            for (let i = 0; i < ary.length; i++) {
                ary[i].style.display = 'none';
            }
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'none';
            }
        }
    }

    openMealPopupSlider(event, e){
        document.querySelector('.mp-slider').style.display = 'none';
        for(let i = 1; i < 4; i++){
            if(document.getElementById('mp-slider'+i).style.display == 'block'){
                document.getElementById('mp-slider'+i).style.display == 'none';
            }
        }
        if(e == 'up'){
            document.getElementById('mp-slider'+event).style.display = 'block';
            document.getElementById('mpup'+event).style.display = 'none';
            document.getElementById('mpdown'+event).style.display = 'block';
        }else{
            document.getElementById('mpdown'+event).style.display = 'none';
            document.getElementById('mp-slider'+event).style.display = 'none';
            document.getElementById('mpup'+event).style.display = 'block';
        }
    }

    render() {
        return (
            <main className="main-container meal-planner">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                {!this.state.isApp && 
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={global.redirect_url+"tools/baby-meal-plan"} className="R11_9e">Baby Meal Planner</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Disclaimer</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Disclaimer</h1>
                </div>
                }
                {this.state.isApp &&
                    <div className="app-header">
                            <span data-icon-font="s" className="icon" onClick={() => onBackPressed()}></span>
                        <span className="M16_pink">Disclaimer</span>
                    </div>
                }
                <div className="sub-container left">
                    <div className="data-container left" style={this.state.isApp ? { marginTop: '50px' } : {}}>
                        <div className="disclaimerBlock gr_info">
                            <div className="topimg" >
                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/2. bubble on FAQ & QNA.png" />
                            </div>
                            <div className="btmimg">
                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/bubble on FAQ & QNA.png" />
                            </div>
                            <div className="distext R14_75">
                                Each child is different and so use these meal plans as a trusted guide as per your discretion. You can modify the meals according to your child’s preferences / requirements.
                            </div>
                            <div className="distext R14_75">
                                Never force-feed a child. 
                            </div>
                            <div className="distext R14_75">
                                While preparing formula, please follow the instructions on the box and use the measuring spoon provided with it. 
                            </div>
                            <div className="distext R14_75">
                                While introducing solid food to a baby, initially, one needs to prepare watery gruels/soups. As a child gets older, the caretaker/ mother has to increase the thickness of the liquids slowly according to the child’s capacity to swallow. Foods that are too thick can cause stomach upset/ unnecessary load; while excessively watery food might cause the child to remain hungry. 
                            </div>
                            <div className="distext R14_75">
                                Some kids may eat less on some days and that is absolutely alright. However, if a child eats less for more than 3-4 consecutive days, please visit a doctor to guide further.
                            </div>
                            <div className="distext R14_75">
                                A child may eat less during the teething phase or if he/she may not be feeling well. You could increase breast milk/formula feeds on those days. Re-introduce the foods once the child is back to normal.
                            </div>
                            <div className="distext R14_75">
                                Don’t stop feeding if the child is suffering from diarrhoea. 
                            </div>
                            <div className="distext R14_75">
                                You can alter the taste of the food by adding some natural flavours like cinnamon, jeera powder, lemon juice, curry leaves etc. if the child doesn’t accept the food initially. 
                            </div>
                            <div className="distext R14_75">
                                If your child suffers from an allergy to nuts, gluten or eggs, please consult your doctor before feeding him/her any foods that may contain them.
                            </div>
                        </div>
                    </div>                   
                </div>
                <div className="new-right-sect">  
                    <Right url={this.props.location.pathname} />
                </div>
            </main>
        )
    }
}

export default withContext(MealPlannerDisclaimer);
